module.exports = __webpack_public_path__ + "img/25.5fd65ca0.jpg";